import {
  Box,
  Button,
  Typography,
  TextField,
  useMediaQuery,
} from "@mui/material";
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

import FormControl from "@mui/material/FormControl";
import { useLocation } from "react-router-dom";

import axios from "axios";
import { toast } from "react-toastify";
import Select from "react-select";
import "./Professionaldetails.css";
import CloseIcon from "@mui/icons-material/Close";

const apiUrl = process.env.REACT_APP_API_REST_URL;

const Professionaldetails = () => {
  const isSmallScreen = useMediaQuery("(max-width:600px)");

  const location = useLocation();
  const userId = location.state?.userId;
  console.log("userid professionwa", userId);
  const [selectedprofone, setSelectedprofone] = useState("");
  const [selectedprofarray, setSelectedprofarray] = useState(null);
  const [selectedheardfromarray, setSelectedheardfromarray] = useState(null);
  const [selectedHeardFrom, setSelectedHeardFrom] = useState("");
  const [selectedcityname, setSelectedcityname] = useState("");
  const [cityarray, setCityarray] = useState(null);
  const [selectedstatename, setSelectedstatename] = useState("");
  const [statearray, setstatearray] = useState(null);
  const [username, setUsername] = useState("");
  const [userarray, setUserarray] = useState(null);
  // const [username, setUsername] = useState("");
  // const [userarray, setUserarray] = useState(null);
  const [othervalue, setothervalue] = useState("");
  const [customProfession, setCustomProfession] = useState(""); //h11

  const errorMessage = "All fields are mandatory!";
  const handleHeardFromChange = (value) => {
    setSelectedHeardFrom(value);
    console.log("selectedheard", selectedHeardFrom);

    // You can do additional handling based on the selected value if needed
  };
  console.log("selected valvaaa", selectedHeardFrom);

  // const handlepointofcontactChange = (selectedOption) => {
  //   setUsername(selectedOption);
  // };
  const handleProfChange = (selectedOption) => {
    setSelectedprofone(selectedOption);
    if (selectedOption.value !== 6) {
      setCustomProfession("");
    }
  };
  const handleCustomProfessionChange = (e) => {
    setCustomProfession(e.target.value);
  };
  const handleStateChange = (selectedOption) => {
    setSelectedstatename(selectedOption);
  };
  const handleCityChange = (selectedOption) => {
    setSelectedcityname(selectedOption);
  };

  const handlepointofcontactChange = (selectedOption) => {
    setUsername(selectedOption);
  };
  const handleCheck = async () => {
    const res = await axios.post(`${apiUrl}/CCE/api/v1/userEngine/users`, {
      roleId: "1,2,6",
    });
    const result = res.data.response;
    console.log("asdfdfglkjdfgjkjhkjl", result);
    const username = result.map((profession) => ({
      value: profession.id,
      label: `${profession.firstname} ${profession.lastname}`,
    }));
    setUserarray(username);
  };

  useEffect(() => {
    handleCheck();
  }, []);
  const data = {
    cityId: selectedcityname?.value,
    professionId: selectedprofone?.value,
    stateId: selectedstatename?.value,
    heardFromId: selectedHeardFrom,
    userId: userId,
    heardFromOther: othervalue,
    pointOfContact: username?.value,
    custom_profession: selectedprofone?.value === 6 ? customProfession : null,
  };

  const getprofessiondata = async () => {
    const nresponse = await axios.get(
      `${apiUrl}/CCE/api/v1/commonEngine/professions`
    );
    console.log("newresponse", nresponse);
    const result = nresponse.data.response;
    const professions = result?.map((profession) => ({
      value: profession.id,
      label: profession.profession_name,
    }));
    setSelectedprofarray(professions);
    console.log("seelve1", professions);
  };
  const getheardfromdata = async () => {
    const resva = await axios.get(
      `${apiUrl}/CCE/api/v1/commonEngine/heardfrom`
    );
    console.log("resva", resva);
    const result = resva.data.response;
    const heardfrom = result.map((profession) => ({
      value: profession.id,
      label: profession.heardFrom_name,
    }));
    setSelectedheardfromarray(heardfrom);
    console.log("herd from", heardfrom);
  };
  const getstatedata = async () => {
    const resva = await axios.get(`${apiUrl}/CCE/api/v1/commonEngine/state`);
    console.log("resvastate", resva);
    const result = resva.data.response;
    console.log("resultstate", result);
    const statename = result.map((profession) => ({
      value: profession.id,
      label: profession.statename
        .toLowerCase()
        .replace(/\b\w/g, (c) => c.toUpperCase()),
    }));
    setstatearray(statename);
    console.log("statearray", statename);
  };
  console.log("selected heard", selectedHeardFrom);
  console.log("seelve2", selectedprofarray);
  const handlesubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(
        `${apiUrl}/CCE/api/v1/userEngine/addProfessionalDetails`,
        data
      );
      console.log("Response:", response.data);
      if (response) {
        toast.success("Profile details added successfully!");
        // Access the 'id' property from the response
        navigate("/congrats");
      }
    } catch (error) {
      console.error("Error:", error.message);
      toast.error("Network error. Please try again.");
    }

    // try {
    //   // Example update request
    //   const updateResponse = await axios.put(`${url}userEngine/updateUser`, {
    //     userId: userId,
    //     "pointOfContact":3,
    //   });

    //   console.log("Update Response:", updateResponse.data);

    //   // Navigate to the "Thank You" page on successful agreement
    // } catch (error) {
    //   console.error("Error updating user:", error.message);
    //   // Handle the error appropriately
    // }
  };
  const navigate = useNavigate();

  // const handleCheck = async () => {
  //   const res = await axios.post(`${url}userEngine/users`, { roleId: 2 });
  //   const result = res.data.response;
  //   const username = result.map((profession) => ({
  //     value: profession.id,
  //     label: `${profession.firstname} ${profession.lastname}`,
  //   }));
  //   // setUserarray(username);
  //   // console.log("asdfdfglkjdfgjkjhkjl",res);
  // };

  const getCitiesdata = async () => {
    const res = await axios.get(`${apiUrl}/CCE/api/v1/commonEngine/cities`);
    console.log("citydata", res);
    const resva = res.data.response;
    const username = resva.map((profession) => ({
      value: profession.id,
      label: profession.cityname,
    }));
    setCityarray(username);
  };

  useEffect(() => {
    getprofessiondata();
    getheardfromdata();
    getstatedata();
    // handleCheck();
    getCitiesdata();
  }, []);

  const handleCancel = () => {
    navigate("/thankyou");
  };
  const customStyles = {
    control: (provided) => ({
      ...provided,
      zIndex: 2, // Ensure the control is above other elements
    }),
    menu: (provided) => ({
      ...provided,
      zIndex: 3, // Ensure the menu is above the control and other elements
    }),
  };
  return (
    <>
      {isSmallScreen ? (
        <span>
          <Box sx={styles.formboxresponsive}>
            <Box
              onClick={handleCancel}
              sx={{
                textAlign: "right",
                cursor: "pointer",
                color: "#666666",
              }}
            >
              <CloseIcon />
            </Box>
            <h2>Professional Details</h2>
            <form onSubmit={handlesubmit}>
              {/* ----------------------------------New code-------------------------------------- */}

              <Box sx={{ marginTop: "12px" }}>
                <Box sx={{ minWidth: 100 }}>
                  <FormControl fullWidth sx={{ textAlign: "left" }}>
                    <Select
                      styles={customStyles}
                      // sx={{ border: "1 px solid green" }}
                      labelId="profession-label"
                      id="profession"
                      value={selectedprofone}
                      onChange={handleProfChange}
                      options={selectedprofarray}
                      isSearchable
                      placeholder="Select Profession"
                    />
                  </FormControl>
                </Box>
                {selectedprofone?.value === 6 && (
                  <TextField
                    label="Other Profession"
                    variant="outlined"
                    fullWidth
                    margin="normal"
                    required
                    value={customProfession}
                    onChange={handleCustomProfessionChange}
                  />
                )}
              </Box>
              <Box sx={{ marginTop: "12px" }}>
                <Box sx={{ minWidth: 100 }}>
                  <FormControl fullWidth sx={{ textAlign: "left" }}>
                    <Select
                      sx={{ border: "1 px solid green" }}
                      labelId="state-label"
                      id="state"
                      value={selectedstatename}
                      onChange={handleStateChange}
                      options={statearray}
                      isSearchable
                      placeholder="Select State"
                    />
                  </FormControl>
                </Box>
              </Box>
              <Box sx={{ marginTop: "12px" }}>
                <Box sx={{ Width: 100 }}>
                  <FormControl fullWidth sx={{ textAlign: "left" }}>
                    <Select
                      sx={{ border: "1 px solid green" }}
                      labelId="city-label"
                      id="city"
                      value={selectedcityname}
                      onChange={handleCityChange}
                      options={cityarray}
                      isSearchable
                      placeholder="Select City"
                    />
                  </FormControl>
                </Box>
              </Box>

              <Box sx={{ marginTop: "0px" }}>
                <Box sx={{ Width: 150 }}>
                  <FormControl sx={{ textAlign: "left" }} fullWidth>
                    <div
                      style={{
                        margin: "8px 0px 8px 0px",

                        fontSize: "16px",
                      }}
                    ></div>
                    <Select
                      sx={{ border: "1 px solid green" }}
                      labelId="profession-label"
                      id="profession"
                      value={username}
                      onChange={handlepointofcontactChange}
                      options={userarray}
                      isSearchable
                      placeholder=" Point of Contact in InvesTek?"
                    />
                  </FormControl>
                </Box>
              </Box>
              <Box>
                <Typography sx={{ textAlign: "left", marginTop: "12px" }}>
                  How did you hear about us?
                </Typography>

                <div>
                  <Box className="radio-container">
                    {selectedheardfromarray?.map((option) => (
                      <div className="radio-item" key={option.value}>
                        <div>
                          <input
                            type="radio"
                            id={`heardFrom_${option.value}`}
                            name="heardFrom"
                            value={option.value}
                            checked={selectedHeardFrom === option.value}
                            onChange={() => handleHeardFromChange(option.value)}
                            style={{ width: "15px", height: "15px" }}
                          />
                        </div>
                        <div>
                          <label htmlFor={`heardFrom_${option.value}`}>
                            {option.label}
                          </label>
                        </div>
                      </div>
                    ))}
                  </Box>
                </div>
                <div>
                  {selectedHeardFrom === 7 ? (
                    <div>
                      {" "}
                      <TextField
                        label="Other"
                        variant="outlined"
                        fullWidth
                        margin="normal"
                        required
                        value={othervalue}
                        onChange={(e) => setothervalue(e.target.value)}
                        // Other props like onChange, value, etc.
                      />
                    </div>
                  ) : null}
                </div>
              </Box>
              {selectedstatename === "" && (
                <p style={{ color: "red", marginBottom: "0px" }}>
                  {errorMessage}
                </p>
              )}
              <Button
                type="submit"
                sx={{
                  ...styles.btn,
                  backgroundColor:
                    selectedprofone === "" ||
                    selectedcityname === "" ||
                    selectedstatename === "" ||
                    username === "" ||
                    (selectedprofone?.value === 6 && customProfession === "")
                      ? "white"
                      : "#002C51",
                }}
                disabled={
                  selectedprofone === "" ||
                  selectedcityname === "" ||
                  selectedstatename === "" ||
                  username === "" ||
                  (selectedprofone?.value === 6 && customProfession === "")
                }
              >
                Submit
              </Button>
              {/* <button onClick={handleCheck}>check</button> */}
            </form>
          </Box>
        </span>
      ) : (
        <span>
          <Box sx={styles.formbox}>
            <Box
              onClick={handleCancel}
              sx={{
                textAlign: "right",
                cursor: "pointer",
                color: "#666666",
              }}
            >
              <CloseIcon />
            </Box>
            <h2>Professional Details</h2>
            <form onSubmit={handlesubmit}>
              {/* ----------------------------------New code-------------------------------------- */}

              <Box sx={{ marginTop: "12px" }}>
                <Box sx={{ minWidth: 100 }}>
                  <FormControl fullWidth sx={{ textAlign: "left" }}>
                    <Select
                      styles={customStyles}
                      // sx={{ border: "1 px solid green" }}
                      labelId="profession-label"
                      id="profession"
                      value={selectedprofone}
                      onChange={handleProfChange}
                      options={selectedprofarray}
                      isSearchable
                      placeholder="Select Profession"
                    />
                  </FormControl>
                </Box>
                {selectedprofone?.value === 6 && (
                  <TextField
                    label="Other Profession"
                    variant="outlined"
                    fullWidth
                    margin="normal"
                    required
                    value={customProfession}
                    onChange={handleCustomProfessionChange}
                  />
                )}
              </Box>
              <Box sx={{ marginTop: "12px" }}>
                <Box sx={{ minWidth: 100 }}>
                  <FormControl fullWidth sx={{ textAlign: "left" }}>
                    <Select
                      sx={{ border: "1 px solid green" }}
                      labelId="state-label"
                      id="state"
                      value={selectedstatename}
                      onChange={handleStateChange}
                      options={statearray}
                      isSearchable
                      placeholder="Select State"
                    />
                  </FormControl>
                </Box>
              </Box>
              <Box sx={{ marginTop: "12px" }}>
                <Box sx={{ Width: 100 }}>
                  <FormControl fullWidth sx={{ textAlign: "left" }}>
                    <Select
                      sx={{ border: "1 px solid green" }}
                      labelId="city-label"
                      id="city"
                      value={selectedcityname}
                      onChange={handleCityChange}
                      options={cityarray}
                      isSearchable
                      placeholder="Select City"
                    />
                  </FormControl>
                </Box>
              </Box>
              <Box sx={{ marginTop: "0px" }}>
                <Box sx={{ Width: 150 }}>
                  <FormControl sx={{ textAlign: "left" }} fullWidth>
                    <div
                      style={{
                        margin: "8px 0px 8px 0px",

                        fontSize: "16px",
                      }}
                    ></div>
                    <Select
                      sx={{ border: "1 px solid green" }}
                      labelId="profession-label"
                      id="profession"
                      value={username}
                      onChange={handlepointofcontactChange}
                      options={userarray}
                      isSearchable
                      placeholder=" Point of Contact in InvesTek?"
                    />
                  </FormControl>
                </Box>
              </Box>

              <Box>
                <Typography sx={{ textAlign: "left", marginTop: "12px" }}>
                  How did you hear about us?
                </Typography>
                <div>
                  <Box className="radio-container">
                    {selectedheardfromarray?.map((option) => (
                      <div className="radio-item" key={option.value}>
                        <div>
                          <input
                            type="radio"
                            id={`heardFrom_${option.value}`}
                            name="heardFrom"
                            value={option.value}
                            checked={selectedHeardFrom === option.value}
                            onChange={() => handleHeardFromChange(option.value)}
                            style={{ width: "15px", height: "15px" }}
                          />
                        </div>
                        <div>
                          <label htmlFor={`heardFrom_${option.value}`}>
                            {option.label}
                          </label>
                        </div>
                      </div>
                    ))}
                  </Box>
                </div>
                <div>
                  {selectedHeardFrom === 7 ? (
                    <div>
                      {" "}
                      <TextField
                        label="Other"
                        variant="outlined"
                        fullWidth
                        margin="normal"
                        required
                        value={othervalue}
                        onChange={(e) => setothervalue(e.target.value)}
                        // Other props like onChange, value, etc.
                      />
                    </div>
                  ) : null}
                </div>
              </Box>
              {selectedstatename === "" && (
                <p style={{ color: "red", marginBottom: "0px" }}>
                  {errorMessage}
                </p>
              )}
              <Button
                type="submit"
                sx={{
                  ...styles.btn,
                  backgroundColor:
                    selectedprofone === "" ||
                    selectedcityname === "" ||
                    selectedstatename === "" ||
                    username === "" ||
                    (selectedprofone?.value === 6 && customProfession === "")
                      ? "white"
                      : "#002C51",
                }}
                disabled={
                  selectedprofone === "" ||
                  selectedcityname === "" ||
                  selectedstatename === "" ||
                  username === "" ||
                  (selectedprofone?.value === 6 && customProfession === "")
                }
              >
                Submit
              </Button>
              {/* <button onClick={handleCheck}>check</button> */}
            </form>
          </Box>
        </span>
      )}
    </>
  );
};

export default Professionaldetails;

const styles = {
  formbox: {
    position: "absolute",
    top: "51%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    padding: "20px",
    background: "#FFFFFF",
    borderRadius: "8px",
    textAlign: "center",
    overflow: "scroll",
    height: "510px",
    width: "460px",
  },
  formboxresponsive: {
    position: "absolute",
    top: "51.5%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    padding: "20px",
    background: "#FFFFFF",
    borderRadius: "8px",
    textAlign: "center",
    // height:"590px",
    width: "320px",
  },
  formboxtwo: {
    position: "absolute",
    top: "90%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    padding: "20px",
    background: "#FFFFFF",
    borderRadius: "8px",
    textAlign: "center",
    height: "30px",
    width: "520px",
  },
  btn: {
    margin: "1em 0em 1em 0em",
    width: "10em",
    backgroundColor: "#002C51",
    color: "white",
    textTransform: "none",
    "&:hover": {
      background: "#002C51",
    },
  },
  textfield: {
    // border:"1px solid red",
    width: "480px",
    height: "30px",
  },
  textfieldres: {
    // border:"1px solid red",
    width: "300px",
    height: "30px",
  },
};
